<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="38rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 22 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 36rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
        <span v-if="(this.forms.emailid && this.forms.status == 2) || (sendflag == 0&&sendflag != '')">編輯郵件</span>
        <span v-else-if="this.forms.emailid && this.forms.status != 2">已發送郵件</span>
        <span v-else>新建郵件</span>
        <!-- {{ this.forms }} -->
        
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div class="content">
        <div style="padding-top: 1rem;">
          <div style="display:flex;align-items: center;">
            <div style="flex-shrink: 0;width: 4.5rem;font-size: 0.8rem;color: #333;">寄件者：</div>
            <a-input v-model="form.sendfrom" style="color: #333;" :disabled="true"/>
          </div>
          <div style="display:flex;align-items: center;margin-top: 1.5rem;">
            <div style="flex-shrink: 0;width: 4.5rem;font-size: 0.8rem;color: #333">收件者：</div>
            <div style="border:1px solid #d9d9d9;border-radius: 4px;width: 100%;height: 1.75rem;padding: 3px 5px;display: flex;overflow-x: hidden;" v-if="this.forms.status != 2">
              <div class="sjzCla" v-for="(item,index) in emailslist" :key="index" v-if="item!=''">{{ item }}</div>
            </div>
            <a-input v-model="emails" style="color: #333;" v-else/>
            <!-- </div> -->
            <div style="display:flex;" >
              <img src="../../image/jjr/ck.png" alt="" style="margin-left: 0.7rem;cursor: pointer;width: 20px;height: 20px;" @click="seeClick()" v-if="this.forms.emailid && this.forms.status != 2">
              <a-upload name="file" :data='{token:$store.state.token}' :headers='{token:$store.state.token}'
                  class="avatar-uploader" :show-upload-list="false" style="margin-left: 0.7rem" :action="$api.uploadEmailsWithExcel"
                  :before-upload="beforeUpload" @change="handleChange" v-if="!this.forms.emailid ||  sendflag == 0">
                <img src="../../image/jjr/sc.png" alt="" style="cursor: pointer;width: 20px;height: 20px;">
              </a-upload>
            </div>
          </div>
          <div style="display:flex;align-items: center;margin-top: 1.5rem;">
            <div style="flex-shrink: 0;width: 4.5rem;font-size: 0.8rem;color: #333">副本：</div>
            <a-space direction="vertical" style="width: 100%;min-height: 1.75rem;" >
              <a-select  v-model="form.emailsadd" mode="tags" style="width: 100%;min-height: 1.75rem;color: #333" :disabled="this.forms.emailid && this.forms.status != 2 && sendflag != 0">
                <a-select-option v-for="(item,index) in result" :key="index" :value="item.email" >{{item.email}}</a-select-option>
              </a-select>
            </a-space>
          </div>
          <div style="display:flex;align-items: center;margin-top: 1.5rem;">
            <div style="flex-shrink: 0;width: 4.5rem;font-size: 0.8rem;color: #333">郵件主題：</div>
            <a-input :disabled="this.forms.emailid && this.forms.status != 2 && sendflag != 0" style="color: #333" v-model="form.subject"/>
          </div>
          <div style="display:flex;align-items: center;margin-top: 1.5rem;">
            <div style="flex-shrink: 0;width: 4.5rem;font-size: 0.8rem;color: #333">郵件內容：</div>
            <a-select v-model="form.yjnr" style="width:100%" :disabled="this.forms.emailid && this.forms.status != 2 && sendflag != 0" @change="modelimg(form.yjnr)">
              <!-- <a-select-option v-for="(item,index) in result" :key="index" :value="item.email">{{item.email}}</a-select-option> -->
              <a-select-option v-for="(item,index) in result1" :key="index" :value="item.modelname" >{{item.modelname}}</a-select-option>
            
            </a-select>
            <img src="../../image/jjr/ck.png" alt="" style="margin-left: 0.7rem;cursor: pointer;width: 20px;height: 20px;" @click="templateClick()">
          </div>
        </div>

        <div style="text-align: center;margin-top: 1.5rem;margin-bottom: 0.5rem;" v-if="!this.forms.emailid || this.forms.status == 2 || sendflag == 0">
            <button class="btnOn" @click="btnOkClick(2)" v-if="this.forms.status != 2">保存</button>
            <button class="btnOK" @click="resendEmail()" v-if="this.forms.status == 2" v-loading.fullscreen.lock="loadingBol">重發 </button >
            <button class="btnOK" @click="btnOkClick(1)" v-else>發送</button>
        </div>
      </div>

      <div style="width: 100%; height: 1px"></div>
    </a-modal>
  </div>
</template>

<script>
import App from "@/assets/app.js";
export default {
  components: {
  },
  props: ["forms"],
  data() {
    return {
    // 重發加載中判斷
      loadingBol : false,
      imgAll:'',
      ishand: false,
      visible: true,
      dataAll:{},
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
      form:{
        sendfrom:'cs@qmis.com.hk',
        subject:'',
        emailsadd:[],
        yjnr:''
      },
      sendflag: '',
      emails: '',
      excelurl: '',
      templateUrl: '',
      emailslist: [],
      result:[],
      result1:[],
     
    };
  },
  mounted() {
    console.log(this.forms);
    this.uploadData()
    this.uploadData1()
    if (this.forms.emailid) {
      this.getEmail()
    }

   
  },

  methods: {
    modelimg(val){
      if(val == '馬丁路德金紀念日電郵'){
        this.templateUrl = this.result1[0].modelurl
      }else{
        this.templateUrl = this.result1[1].modelurl
      }
    },
    handleCancel(ev) {
        this.$emit("child", 0);
    },
    btnOkClick(val){
      if (this.emailslist.length <= 0 && this.form.emailsadd.length <= 0) {
        App.oTool.warningT('請添加收件者');
        return
      }
      if (!this.form.subject) {
        App.oTool.warningT('請添写郵件主題');
        return
      }
      if (!this.form.yjnr) {
        App.oTool.warningT('請選擇郵件內容');
        return
      }
      if (val == 2) {
        this.echoData()
      }
      if (val == 1) {
        this.echoData(1)
      }
    },

    echoData(sendflag){
      // console.log(this.form.emailsadd.join(","));
      var emailsadd = this.form.emailsadd.join(",");
      this.$ajax({
        method: "post",
        url: this.$api.newEmailRecord,
        // url: 'http://192.168.31.203:6785/admin/newEmailRecord',
        data: {
          sendfrom:this.form.sendfrom,
          emails:this.emails,
          subject:this.form.subject,
          emailid:this.forms.emailid,
          recordid:this.forms.recordid,
          emailsadd:emailsadd,
          modelname:this.form.yjnr,
          excelbase64: this.Base64,
          sendflag:sendflag
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.dataAll = res.data;
          if (sendflag == 1) {
            App.oTool.successT('操作成功');
          }else{
            App.oTool.successT('保存成功');
          }
          this.$emit("child", 0);
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    uploadData(file){
      this.$ajax({
        method: "post",
        url: this.$api.uploadEmailsWithExcel,
        data: {
          file:file,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    getEmail(){
      this.$ajax({
        method: "post",
        url: this.$api.getEmailRecordWithEmailid,
        data: {
          emailid:this.forms.emailid,
          recordid:this.forms.recordid,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.emailslist = res.data.emails.split(',');
          this.emails = res.data.emails;
          this.excelurl = res.data.excelurl;
          if (res.data.emailsadd) {
            this.form.emailsadd = res.data.emailsadd.split(',');
          }
          this.form.subject = res.data.subject;
          this.sendflag = res.data.sendflag;
          this.form.yjnr = res.data.modelname;
          if(this.form.yjnr == '馬丁路德金紀念日電郵'){
            this.templateUrl = this.result1[0].modelurl
          }else{
            this.templateUrl = this.result1[1].modelurl
          }
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    uploadData(){
      this.$ajax({
        method: "post",
        url: this.$api.getParamList,
        data: {
          type:'adminemail',
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.result = res.data.result
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    uploadData1(){
      this.$ajax({
        method: "post",
        url: this.$api.getParamList,
        data: {
          type:'emailmodel',
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.result1 = res.data.result
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    resendEmail(){
      var emailsadd = this.form.emailsadd.join(",");
      this.loadingBol = true;
      this.$ajax({
        method: "post",
        url: this.$api.resendEmail,
        data: {
          // recordid:this.forms.recordid,
          sendfrom:this.form.sendfrom,
          emails:this.emails,
          subject:this.form.subject,
          emailid:this.forms.emailid,
          recordid:this.forms.recordid,
          emailsadd:emailsadd,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          App.oTool.successT('操作成功');
          this.loadingBol = false;
          this.$emit("child", 0);
        } else {
          this.loadingBol = false;
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    handleChange(info) {
      if (info.file.response) {
        if (info.file.response.qmiscode == 1000) {
          console.log(document.getElementsByClassName("ant-upload"));
          this.loading = true;
          this.Base64 = info.file.response.excelfileBase64
          console.log(info.file.response);
          this.emails = info.file.response.emails;
          this.emailslist = info.file.response.emailslist;
          this.$message.success('導入成功');
          // this.messLoad();
        } else {
          this.loading = false;
          this.$message.error(info.file.response.qmismsg);
        }
      }
    },
    beforeUpload(file) {
      var fileFormat = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();
      const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
      if (!isJpgOrPng) {
        this.$message.error('只能上傳xls或xlsx文件!');
      }
      return isJpgOrPng;
    },
    seeClick(){
      if (this.excelurl) {
        window.open(this.excelurl, '_blank')
      }
      
    },
    templateClick(){
      if (this.templateUrl) {
        window.open(this.templateUrl, '_blank')
      }
    }


  },
};
</script>

<style lang="scss">
.el-loading-spinner .path{
  stroke:#0c8b97
}
.ant-select-disabled .ant-select-selection--multiple .ant-select-selection__choice{
  color: rgba(0, 0, 0, 0.65);
  background: #e6f6f8;
}
.ant-select-selection--multiple .ant-select-selection__choice{
  background-color: #e6f6f8;
}
.ant-select-selection--multiple .ant-select-selection__rendered{
  min-height: 1.75rem;
}
.ant-select-selection--multiple > ul > li, .ant-select-selection--multiple .ant-select-selection__rendered > ul > li{
  min-height: 1.3rem;
  line-height: 1.3rem;
}
.btnOn{
  margin-right: 15%;
  background: #0c8b97;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
  cursor: pointer;
}
.btnOK{
  background: #f48d28 ;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
  cursor: pointer;
}
.myStyle{
  border-bottom: none !important;
}
.show-more{
  text-align: center;
}
.score-img {
  width: 16px;
  transition: all 0.3s;
}
.rotate-img {
  transform: rotate(180deg);
}
.content-top1{
  width: 100%;
  height: 60px;
  background:#ffffff; 
  color: #000000;
  line-height: 60px;
  display: flex;
  padding: 0 20px;

}
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 35%;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 36rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 8%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .denglu .ant-select{
    width: 9rem;
  }
  .sjzCla{
    height: 1.3rem;
    line-height: 1.3rem;
    border: 1px solid #e8e8e8;
    background-color: #e6f6f8;
    padding: 0 10px;
    margin-right:4px
  }
}
</style>
